import {ChangeDetectorRef, OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {Subscription} from 'rxjs';
import {TranslateService} from '@core/modules/translation/services/translate.service';

@Pipe({
	standalone: true,
	name: 'translate',
	pure: false,
})
export class TranslatePipe implements PipeTransform, OnDestroy {
	private subscription: Subscription;

	constructor(
		private translate: TranslateService,
		private ref: ChangeDetectorRef
	) {
		// Mark OnPush components for check when translations load or language changes
		this.subscription = this.translate.onLangChange.subscribe(() => {
			this.ref.markForCheck();
		});
	}

	transform = (key: string, param?: {[param: string]: string}) =>
		this.translate.translate(param ? {key, param} : key);

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
